import { UpdateUserRequest, UserOrganizationRequest } from '../models/user.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserFilterPaginatedRequest } from '../models/user-filter-paginated.model';
import { SessionStateService } from '../../core/session-state.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(
    private http: HttpClient,
    private sessionState: SessionStateService,
  ) {}

  /**
   * PUT /api/User
   * @param body UpdateUserRequest
   */
  putUser(body: UpdateUserRequest): Observable<any> {
    return this.http.put(`${environment.apiUrl}/api/User`, body);
  }

  /**
   * POST /api/User/filter-paginated
   * @param body UserFilterPaginatedRequest
   */
  userFilterPaginated(body: UserFilterPaginatedRequest): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/api/User/filter-paginated`,
      body,
    );
  }

  /**
   * GET /api/User/{id} where id is userId from session
   */
  getUserByUserId(): Observable<any> {
    const userId = this.sessionState.userId();
    if (!userId) {
      throw new Error('userId not found in session');
    }
    return this.http.get(`${environment.apiUrl}/api/User/${userId}`);
  }

  /**
   * POST /api/User/organization
   * @param body UserOrganizationRequest
   */
  postOrganization(body: UserOrganizationRequest): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/User/organization`, body);
  }
}
